import { render } from "./ADSList.vue?vue&type=template&id=2ec2761c&ts=true"
import script from "./ADSList.vue?vue&type=script&lang=ts"
export * from "./ADSList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__